// Predefined themes for ReqTrak - Request. Track. Resolve.
// Each theme includes primary, secondary, accent colors and additional styling

export const predefinedThemes = {
  default: {
    name: "Police Blue",
    description: "Classic police department colors",
    primary_color: "#2563eb",
    secondary_color: "#1e40af", 
    accent_color: "#3b82f6",
    background_gradient: "from-blue-50 to-indigo-50",
    card_gradient: "from-white to-blue-50",
    button_gradient: "from-blue-600 to-indigo-600",
    text_primary: "#1e293b",
    text_secondary: "#64748b",
    preview_image: "/themes/police-blue.jpg"
  },
  
  professional: {
    name: "Professional Gray",
    description: "Clean and professional appearance",
    primary_color: "#374151",
    secondary_color: "#1f2937",
    accent_color: "#6b7280",
    background_gradient: "from-gray-50 to-slate-50",
    card_gradient: "from-white to-gray-50", 
    button_gradient: "from-gray-600 to-slate-600",
    text_primary: "#111827",
    text_secondary: "#6b7280",
    preview_image: "/themes/professional-gray.jpg"
  },

  justice: {
    name: "Justice Green",
    description: "Authority and trust symbolism",
    primary_color: "#059669",
    secondary_color: "#047857",
    accent_color: "#10b981",
    background_gradient: "from-emerald-50 to-green-50",
    card_gradient: "from-white to-emerald-50",
    button_gradient: "from-emerald-600 to-green-600", 
    text_primary: "#064e3b",
    text_secondary: "#6b7280",
    preview_image: "/themes/justice-green.jpg"
  },

  authority: {
    name: "Authority Navy",
    description: "Strong and trustworthy navy theme",
    primary_color: "#1e3a8a",
    secondary_color: "#1e40af",
    accent_color: "#3b82f6",
    background_gradient: "from-blue-50 to-navy-50",
    card_gradient: "from-white to-blue-50",
    button_gradient: "from-blue-800 to-indigo-800",
    text_primary: "#1e293b", 
    text_secondary: "#64748b",
    preview_image: "/themes/authority-navy.jpg"
  },

  safety: {
    name: "Safety Orange",
    description: "High visibility and emergency theme",
    primary_color: "#ea580c",
    secondary_color: "#c2410c",
    accent_color: "#fb923c",
    background_gradient: "from-orange-50 to-red-50",
    card_gradient: "from-white to-orange-50",
    button_gradient: "from-orange-600 to-red-600",
    text_primary: "#9a3412",
    text_secondary: "#78716c",
    preview_image: "/themes/safety-orange.jpg"
  },

  modern: {
    name: "Modern Purple",
    description: "Contemporary and innovative design",
    primary_color: "#7c3aed",
    secondary_color: "#6d28d9", 
    accent_color: "#a855f7",
    background_gradient: "from-purple-50 to-violet-50",
    card_gradient: "from-white to-purple-50",
    button_gradient: "from-purple-600 to-violet-600",
    text_primary: "#581c87",
    text_secondary: "#64748b",
    preview_image: "/themes/modern-purple.jpg"
  },

  municipal: {
    name: "Municipal Teal",
    description: "Government and civic service theme", 
    primary_color: "#0891b2",
    secondary_color: "#0e7490",
    accent_color: "#06b6d4",
    background_gradient: "from-cyan-50 to-teal-50",
    card_gradient: "from-white to-cyan-50",
    button_gradient: "from-cyan-600 to-teal-600",
    text_primary: "#0f172a",
    text_secondary: "#64748b", 
    preview_image: "/themes/municipal-teal.jpg"
  },

  classic: {
    name: "Classic Burgundy",
    description: "Traditional and distinguished",
    primary_color: "#991b1b",
    secondary_color: "#7f1d1d",
    accent_color: "#dc2626", 
    background_gradient: "from-red-50 to-rose-50",
    card_gradient: "from-white to-red-50",
    button_gradient: "from-red-700 to-rose-700",
    text_primary: "#7f1d1d",
    text_secondary: "#78716c",
    preview_image: "/themes/classic-burgundy.jpg"
  },

  fresh: {
    name: "Fresh Mint",
    description: "Modern and approachable design",
    primary_color: "#059669",
    secondary_color: "#047857",
    accent_color: "#34d399",
    background_gradient: "from-mint-50 to-emerald-50", 
    card_gradient: "from-white to-mint-50",
    button_gradient: "from-emerald-500 to-teal-500",
    text_primary: "#064e3b",
    text_secondary: "#6b7280",
    preview_image: "/themes/fresh-mint.jpg"
  },

  executive: {
    name: "Executive Black",
    description: "Premium and sophisticated look",
    primary_color: "#111827",
    secondary_color: "#1f2937",
    accent_color: "#4b5563",
    background_gradient: "from-slate-50 to-gray-100",
    card_gradient: "from-white to-slate-50", 
    button_gradient: "from-gray-800 to-slate-800",
    text_primary: "#111827",
    text_secondary: "#6b7280",
    preview_image: "/themes/executive-black.jpg"
  }
};

// Helper function to apply theme to CSS variables
export const applyTheme = (theme) => {
  const root = document.documentElement;
  
  root.style.setProperty('--primary-color', theme.primary_color);
  root.style.setProperty('--secondary-color', theme.secondary_color);
  root.style.setProperty('--accent-color', theme.accent_color);
  root.style.setProperty('--text-primary', theme.text_primary);
  root.style.setProperty('--text-secondary', theme.text_secondary);
  
  // Update body classes for gradient backgrounds
  document.body.className = document.body.className.replace(/bg-gradient-to-br from-\S+ to-\S+/, '');
  document.body.classList.add('bg-gradient-to-br', ...theme.background_gradient.split(' '));
};

// Get theme by name
export const getTheme = (themeName) => {
  return predefinedThemes[themeName] || predefinedThemes.default;
};

// Get all theme names
export const getThemeNames = () => {
  return Object.keys(predefinedThemes);
};